module.exports = __webpack_public_path__ + "static/img/5.0abbf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/5.png
// module id = K5G2
// module chunks = 0